const polePosition = [-1, 0, 0.4];
const targetPos = [-1, 5.2, 0.7];

const singleLuminaireConfig = {

	configValues: {
		design: 'pole',
		poleHeight: 9,
		poleDiameter: '140',
		poleShape: 'cylindrical',
		numberOfHeads: 1,
		bracket: '195',
		opticalSystem: 'Comfort',
		layoutType: 'spiral',
		housingSize: '195',
		color: '#666',
		heightMax: 9,
		heightMin: 5,
		angleMax: 360,
		angleMin: 0,
		heads: [],
		selectedHead: null,
	},
	position: polePosition,
	targetPos: targetPos
};

const head = {
	active: 1,
	type: 'luminaire', //luminaire
	housingSize: '195',
	bracket: '195',
	design: 'pole',
	opticalSystem: 'Comfort',
	height: targetPos[1],
	angle: 10,
	pitch: 45,
	roll: 0,
	colourTemperature: '3000K',
	lightDistribution: '30',
	reflectorColour: 'gold',
	cap: 'short', // short, long, asymmetric
	modifier: 'none', // none, honeycomb
	dimmingLevel: null,
	accessories: 'None',
	spcDecisions: null,
	collisions: [],
};
singleLuminaireConfig.configValues.heads.push(head);

export {singleLuminaireConfig};
